import { Icons } from './Icons';
import { LINKS } from '../constants';
import { useInView } from '../hooks';
import styles from './CTA.module.css';

export default function CTA({ t }) {
  const [ref, inView] = useInView(0.2);

  return (
    <section className={styles.section}>
      <div className={styles.glow} />
      <div
        ref={ref}
        className={styles.inner}
        style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(20px)', transition: 'all 0.7s ease' }}
      >
        <div className={styles.label}>{t.sectionLabel}</div>
        <h2 className={styles.title}>
          {t.title1}<br />{t.title2}
        </h2>
        <p className={styles.sub}>{t.sub}</p>
        <div className={styles.actions}>
          <a href={LINKS.buy} target="_blank" rel="noopener noreferrer" className={styles.btnPrimary}>
            {t.btn1} <Icons.Arrow />
          </a>
          <a href={LINKS.dex} target="_blank" rel="noopener noreferrer" className={styles.btnGhost}>
            {t.btn2} <Icons.ExternalLink />
          </a>
        </div>
      </div>
    </section>
  );
}
